import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from './views/login/Login.vue';
import handleRouter from './handleRouter';

Vue.use(VueRouter);
//recharge-center

const routers = [
    // {
    //     path: '/',
    //     redirect: {
    //         name: 'login'
    //     }
    // },
    {
        path: '/admin-login',
        name: 'admin-login',
        component: () => import('./views/login/admin-login.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登陆',
        },
        component: Login
    },
    {
        path: '/api/:name',
        name: 'api-detail',
        component: () => import('./views/home/Api-detail/views.vue')
    },

    {
        path: '/home',
        // name: 'home',
        component: () => import('./views/home/index.vue'),
        children: [{
                path: '/',
                component: () => import('./views/home/home-content.vue')
            },
            {
                path: 'api-book',
                name: 'api-book',
                title_box:{
                  title:'API文档'
                },
                component: () => import('./views/home/Api-book/views.vue')
            },
            {
                path: 'api-key',
                name: 'api-key',
                title_box:{
                  title:'API KEY'
                },
                component: () => import('./views/home/APP-management/views.vue')
            },
            {
                path: 'recharge-center',
                name: 'recharge-center',
                title_box:{
                  title:'充值'
                },
                component: () => import('./views/home/Recharge-center/views.vue')
            },

            {
                path: 'detect',
                name: 'detect',
                title_box:{
                    title:'人脸检测'
                },
                component: () => import('./views/home/Face-recognition/detect/views.vue')
            },
            {
                path: 'agegender',
                name: 'agegender',
                title_box:{
                  title:'人脸年龄性别检测'
                },
                component: () => import('./views/home/Face-recognition/age-gender/views.vue')
            },
            {
                path: 'detecthead',
                name: 'detecthead',
                title_box:{
                  title:'人头检测'
                },
                component: () => import('./views/home/Face-recognition/detect-head/views.vue')
            },
            {
                path: 'emotion',
                name: 'emotion',
                title_box:{
                  title:'表情识别'
                },
                component: () => import('./views/home/Face-recognition/emotion/views.vue')
            },
            {
                path: 'faceaging',
                name: 'faceaging',
                title_box:{
                  title:'人脸老化'
                },
                component: () => import('./views/home/Face-recognition/face-aging/views.vue')
            },
            {
                path: 'facecompare',
                name: 'facecompare',
                title_box:{
                  title:'人脸对比'
                },
                component: () => import('./views/home/Face-recognition/face-compare/views.vue')
            },
            {
                path: 'generate_3d_model',
                name: 'generate_3d_model',
                title_box:{
                  title:'人脸三维重建'
                },
                component: () => import('./views/home/Face-recognition/generate-3d-model/views.vue')
            },
            {
                path: 'haircolor',
                name: 'haircolor',
                title_box:{
                  title:'头发染色'
                },
                component: () => import('./views/home/Face-recognition/hair-color/views.vue')
            },
            {
                path: 'hairsegement',
                name: 'hairsegement',
                title_box:{
                  title:'头发分割'
                },
                component: () => import('./views/home/Face-recognition/hair-segement/views.vue')
            },
            {
                path: 'landmarks',
                name: 'landmarks',
                title_box:{
                    title:'人脸关键点检测'
                },
                component: () => import('./views/home/Face-recognition/landmarks/views.vue')
            },
            {
                path: 'makeupswap',
                name: 'makeupswap',
                title_box:{
                  title:'妆容迁移'
                },
                component: () => import('./views/home/Face-recognition/makeupswap/views.vue')
            },
            {
                path: 'swapface',
                name: 'swapface',
                title_box:{
                  title:'人脸融合'
                },
                component: () => import('./views/home/Face-recognition/swapface/views.vue')
            },
            {
                path: 'texture-swap-3d',
                name: 'texture-swap-3d',
                title_box:{
                  title:'3D人脸融合'
                },
                component: () => import('./views/home/Face-recognition/texture-swap-3d/views.vue')
            },
            {
                path: 'beautyrank',
                name: 'beautyrank',
                title_box:{
                  title:'颜值评分'
                },
                component: () => import('./views/home/Face-recognition/beautyrank/views.vue')
            },
            {
                path: 'skinclassify',
                name: 'skinclassify',
                title_box:{
                  title:'肤色分类'
                },
                component: () => import('./views/home/Face-recognition/skin-classify/views.vue')
            },
            {
                path: 'imagemakeup',
                name: 'imagemakeup',
                title_box:{
                  title:'照片上妆'
                },
                component: () => import('./views/home/Face-recognition/image-makeup/views.vue')
            },
            {
                path: 'skinrun',
                name: 'skinrun',
                title_box:{
                  title:'肤质检测'
                },
                component: () => import('./views/home/Face-recognition/skinrun/views.vue')
            },
            {
                path:'try-on-glasses',
                name:'try-on-glasses',
                title_box:{
                    title:'2d眼镜试戴'
                },
                component: () => import('./views/home/try-on/try-on-glasses/views.vue')
            },
            {
                path:'3d',
                name:'3d',
                title_box:{
                    title:'3d眼镜试戴'
                },
                component: () => import('./views/home/try-on/3D/views.vue')
            },
            {
                path:'hairstyle-try',
                name:'hairstyle-try',
                component: () => import('./views/home/try-on/hairstyle-try/views.vue')
            },
            {
                path:'material-Glasses-to-try',
                name:'material-Glasses-to-try',
                title_box: {
                    title: '2D眼镜试戴素材',
                },
                component: () => import('./views/home/material/material-Glasses-to-try/views.vue')
            },
            {
                path:'3D-glasses-trial-material',
                name:'3D-glasses-trial-material',
                title_box: {
                    title: '3D眼镜试戴素材',
                },
                component: () => import('./views/home/material/3D-glasses-trial-material/views.vue')
            }

        ]

    },
    {
        path: '/panx-home',
        // name: 'panx-home',
        component: () => import('./views/panx-home/index.vue'),
        children: [{
                path: '/',
                component: () => import('./views/panx-home/home-content.vue')
            },
            {
                path: 'panx-api-key',
                name: 'panx-api-key',
                component: () => import('./views/panx-home/APP-management/views.vue')
            },
            {
                path: 'panx-financial-center',
                name: 'panx-financial-center',
                component: () => import('./views/panx-home/Financial-center/views.vue')
            },
            {
                path: 'panx-billing-plan',
                name: 'panx-billing-plan',
                component: () => import('./views/panx-home/Billing-plan/views.vue')
            },
            {
                path: 'panx-financial-detail',
                name: 'panx-financial-detail',
                component: () => import('./views/panx-home/Financial-detail/views.vue')
            },

        ]
    }
]

// 路由配置
const RouterConfig = {
    // mode: 'history',
    mode: 'hash',
    routes: routers,
};

const router = new VueRouter(RouterConfig);

router.beforeEach(handleRouter.before);
router.afterEach(handleRouter.after);

export default router;
